import React from 'react';
import PropTypes from 'prop-types';

import { HUB_SLICE_TYPES } from 'dpl/prismic/utils/customPropTypes';
import ErrorBoundary from 'dpl/prismic/components/ErrorBoundary';

import SLICE_TYPE_TO_COMPONENT from '../utils/sliceTypeToComponent';

export default function HubBody({ hub, slices }) {
  return (
    <div className="PrismicHubBody">
      {slices &&
        slices.map((slice, idx) => {
          const Component = SLICE_TYPE_TO_COMPONENT[slice.slice_type];

          if (!Component) {
            return null;
          }

          return (
            <ErrorBoundary key={idx}>
              <div className="mb8 mb12-md mb14-lg">
                <Component hub={hub} sliceData={slice} />
              </div>
            </ErrorBoundary>
          );
        })}
    </div>
  );
}

HubBody.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  hub: PropTypes.object.isRequired,
  slices: PropTypes.arrayOf(
    PropTypes.shape({
      slice_type: PropTypes.oneOf(Object.values(HUB_SLICE_TYPES)),
      // eslint-disable-next-line react/forbid-prop-types
      primary: PropTypes.object,
      // eslint-disable-next-line react/forbid-prop-types
      items: PropTypes.array
    })
  )
};

HubBody.defaultProps = {
  slices: []
};
